'use client';

import * as React from 'react';

export function WebchatButton(): React.JSX.Element {
  const handleSetMessage = () => {
    const webchatAnimation = document.querySelector('.webchat-animation');
    if (webchatAnimation) {
      const textarea = webchatAnimation.querySelector('textarea');
      if (textarea instanceof HTMLTextAreaElement) {
        textarea.value = 'copilot automation test 1';
        // Trigger input event to notify React/framework of the change
        const event = new Event('input', { bubbles: true });
        textarea.dispatchEvent(event);
      }
    }
  };

  const handleSendMessage = () => {
    const webchatAnimation = document.querySelector('.webchat-animation');
    if (webchatAnimation) {
      const img = webchatAnimation.querySelector('img[alt="Enviar"]');
      if (img) {
        const button = img.closest('button');
        if (button instanceof HTMLButtonElement) {
          button.click();
        }
      }
    }
  };

  return (
    <>
      <button
        onClick={() => {
          const launcher = document.querySelector('.webchat-launcher');
          if (launcher instanceof HTMLElement) {
            launcher.click();
          }
        }}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          padding: '12px 24px',
          backgroundColor: '#0070f3',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          zIndex: 9999
        }}
      >
        Open Chat
      </button>

      <button
        onClick={handleSetMessage}
        style={{
          position: 'fixed',
          bottom: '70px',
          right: '20px',
          padding: '12px 24px',
          backgroundColor: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          zIndex: 9999
        }}
      >
        Set Message
      </button>

      <button
        onClick={handleSendMessage}
        style={{
          position: 'fixed',
          bottom: '120px',
          right: '20px',
          padding: '12px 24px',
          backgroundColor: '#f59e0b',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          zIndex: 9999
        }}
      >
        Send Message 2
      </button>
    </>
  );
}
